export default function goUp() {
  window.scrollTo({
    top:0,
    behavior:"smooth"
  })
}
